<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UpoAXx/media/FC-9798889103820.jpg?1733711399601" alt="This image is the cover for the book The CurE"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The CurE
      </h1>
      <p class="bookDescription body article font2">
        <p>In a pre-apocalyptic world, 17-year-old Calgary teen Julia Klassen is going nowhere … fast.</p><p>Suspended from high school for fighting, Julia is attending summer school to graduate, in addition to anger-management sessions and staying under the radar of Alberta’s governing right-wing party’s Gender Appropriation Division.</p><p>You would think that would be enough chaos in the teen’s life. However, a global terrorism attack on small-modular reactors by environmental group, Terra Nova, says otherwise. As nuclear facilities are compromised by a computer virus coined ‘The CurE’ in an attempt to reset the earth, Julia is pressed into action and rescues a bus load of passengers from explosions and earthquakes in the aftermath.</p><p>As thousands flee contamination zones, the teen decides it’s the perfect time to come out as being transfluid. Fortunately, the pun-loving, quirky Christian Klassens embrace the new Jules. But it isn’t until they find sanctuary at the Church of the Holy Creator in the Piikani Nation of Southern Alberta, however, that Jules gets a taste of true belonging and healing, with the help of Two-Spirit friend, Todd, and Rev. Erin Stillwater.</p><p>It isn’t long before Jules is once again forced into a maturity pressure cooker, as the Klassens join other ex-pats from Atlantic Canada on the Exodus Train in a resettlement lottery program. Along the way, the teen joins Todd and their little brother, Jake, in foiling poachers, rioters and their inner demons in this action-packed adventure that pits wits and will against extremism in the fight for humankind.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        K.S. King
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0mm;margin-bottom:.0001pt;font-size:16px;font-family:"Calibri",sans-serif;text-align:justify;background:white;'><span style='font-size:15px;font-family:"Times New Roman",serif;color:black;'>K.S. King is an award-winning Canadian journalist, reporting and editing publications on crime and courts, education, politics, oil and gas, agriculture, indigenous relations and the environment. Growing up in a rural Newfoundland out-port community, Savage Cove, (pop. 133), King was surrounded by storytellers, fishermen, hunters, tanners, gardeners, and crafters. She is married to an Anglican pastor; has two LGBTQ2S+ sons and routinely volunteers in the LGBTQ2S+ community, Anglican ministries, and facilitating Christian women&rsquo;s retreats.</span></p><p style='margin:0mm;margin-bottom:.0001pt;font-size:16px;font-family:"Calibri",sans-serif;text-align:justify;background:white;'><br></p><p style='margin:0mm;margin-bottom:.0001pt;font-size:16px;font-family:"Calibri",sans-serif;text-align:justify;background:white;'><span style='font-size:15px;font-family:"Times New Roman",serif;color:black;'>Today, King shares her journalism and communication knowledge, as well as her love of reading, to students and staff as middle-school librarian in Calgary.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4b952929